<script>
  export default {
    mounted() {
      this.$root.botaoAcaoMostrar = false;
    }
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/projetos-termino/componentes/TerminoProjetos.vue